angular.module('picmonic-common').factory('TestimonialTagsResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/testimonial_tags/:resource', { resource: '@resource' }, {});
  },
]);
